module.exports = __webpack_public_path__ + "img/Pattern05.6b9aeea1.png";